export function getActivePageFromPath(pathname) {
  if (pathname === "/") return "home";
  if (pathname.startsWith("/about")) return "about";
  if (pathname.startsWith("/contact")) return "contact";
  if (pathname.startsWith("/Request")) return "Request";
  if (pathname.startsWith("/login") || pathname.startsWith("/signup")) return "login";
  if (
    pathname.startsWith("/products") ||
    pathname.startsWith("/allproducts") ||
    pathname.startsWith("/categoryproduct") ||
    pathname.startsWith("/product/")
  ) {
    return "product";
  }
  if (pathname.startsWith("/profile") || pathname.startsWith("/edit-profile")) {
    return "profile";
  }
  if (pathname.startsWith("/myorders") || pathname.startsWith("/orders")) {
    return "orders";
  }
  return "home";
}
